export function duration_in_minutes( duration: string  ) {
    const timeParts = duration.split( ':' )
    return Number( timeParts[0] ) * 60 + Number( timeParts[1] )
}

export function minutes_to_duration( min: number ) {
    let minutes: number = min
    const sign = ( minutes >= 0 ? '' : '-' )

    minutes = Math.abs( minutes )

    const h: number = Math.floor( minutes / 60 )
    let mm: string|number  = minutes % 60

    if ( mm < 10 ) {
        mm = `0${mm}`
    }

    return `${sign}${h}:${mm}`
}
